<template>
  <router-view @load-finished="emitLoadFinished" />
</template>

<script>
export default {
  name: "UnregisteredUserPage",
  methods: {
    emitLoadFinished() {
      this.$emit("load-finished");
    },
  },
};
</script>
